import React from "react";
import {Link} from "react-router-dom";

function NavBar() {
    return (
    <>
        <ul className="flex bg-sky-800 space-x-2 h-12">
            <li className="">
                <Link to="/" className="flex p-2 hover:bg-cyan-500 h-full w-full text-white">Home</Link>
            </li>
            <li className="">
                <Link to="/tictactoe" className="flex p-2 hover:bg-cyan-500 h-full w-full text-white">Tic-Tac-Toe</Link>
            </li>
            <li className="">

            </li>
            <li className="">
                <a href="https://mquirmbach.de/nextcloud" className="flex p-2 hover:bg-cyan-500 h-full w-full text-white">Cloud</a>
            </li>
            <li className="">
                <Link to="/community" className="flex p-2 hover:bg-cyan-500 h-full w-full text-white">Community</Link>
            </li>
        </ul>
    </>
    )
}

export default NavBar;